import { defineComponent as _defineComponent } from 'vue'
import { computed, isRef } from 'vue';
import { CheckboxInputData } from './types';

interface CheckboxInputProps {
    data: CheckboxInputData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
    data: CheckboxInputData;
};



const resolvedValue = computed(() => {
    const current = props.data.value;
    const val = isRef(current) ? current.value : current;
    return val;
});

return { __sfc: true,props, resolvedValue }
}

})